import { useSubscriptionContext } from './context';
import IwocaPayPage from './Pages/IwocaPay';
import PayMonthlyForm from './PayMonthlyForm';
import SignContractForm from './SignContractForm';

const SetupSubscriptionContent: React.FunctionComponent = function () {
  const { display } = useSubscriptionContext();
  if (display === 'contract') return <SignContractForm />;
  if (display === 'iwoca') return <IwocaPayPage />;
  return <PayMonthlyForm />;
};

export default SetupSubscriptionContent;
